
import React from 'react';
import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';

interface TaskCardSkeletonProps {
  index?: number;
}

const TaskCardSkeleton: React.FC<TaskCardSkeletonProps> = ({ index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05, duration: 0.3 }}
      className="p-4 rounded-xl border border-white/20 dark:border-white/10 
                 bg-gradient-to-br from-white/80 to-white/40 dark:from-slate-800/80 dark:to-slate-900/40 
                 backdrop-blur-sm shadow-sm"
    >
      {/* Header with title and priority */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <Skeleton className="h-4 w-3/4 mb-2" />
          <Skeleton className="h-3 w-full" />
        </div>
        <Skeleton className="h-6 w-6 rounded-full ml-3" />
      </div>
      
      {/* Tags row */}
      <div className="flex items-center gap-2 mb-3">
        <Skeleton className="h-5 w-16 rounded-full" />
        <Skeleton className="h-5 w-12 rounded-full" />
        <Skeleton className="h-5 w-14 rounded-full" />
      </div>
      
      {/* Footer with date and actions */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-3 w-20" />
        <div className="flex items-center gap-1">
          <Skeleton className="h-6 w-6 rounded" />
          <Skeleton className="h-6 w-6 rounded" />
        </div>
      </div>
    </motion.div>
  );
};

export default TaskCardSkeleton;
